module.exports = __webpack_public_path__ + "4145471c527604b90b452e2bb7ef3ba3.jpg";